import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "appsContainer"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  "class": "appsContainer__button-container"
}, null, -1);
var _hoisted_3 = {
  "class": "appsContainer__title"
};
var _hoisted_4 = {
  "class": "appsContainer__toggleButton-container"
};
var _hoisted_5 = {
  key: 0,
  "class": "appsContainer__list"
};
var _hoisted_6 = {
  key: 1,
  "class": "appsContainer__list"
};
var _hoisted_7 = {
  key: 2,
  "class": "appsContainer__add"
};
var _hoisted_8 = {
  "class": "flex-parent"
};
var _hoisted_9 = {
  "class": "flex-parent"
};
var _hoisted_10 = {
  "class": "flex-child flex-child-lg"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ButtonBasic = _resolveComponent("ButtonBasic");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, "My " + _toDisplayString($props.itemName) + "s", 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_ButtonBasic, {
    "class": _normalizeClass({
      'appsContainer__toggleButton': true,
      'appsContainer__toggleButton--active': $data.showListA
    }),
    onClick: _cache[0] || (_cache[0] = function ($event) {
      $data.showListA = true;
      $data.showListB = false;
    })
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode("(" + _toDisplayString($props.listCountA) + ") " + _toDisplayString($props.listATitle), 1)];
    }),
    _: 1
  }, 8, ["class"]), _createVNode(_component_ButtonBasic, {
    "class": _normalizeClass({
      'appsContainer__toggleButton': true,
      'appsContainer__toggleButton--active': $data.showListB
    }),
    onClick: _cache[1] || (_cache[1] = function ($event) {
      $data.showListB = true;
      $data.showListA = false;
    })
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode("(" + _toDisplayString($props.listCountB) + ") " + _toDisplayString($props.listBTitle), 1)];
    }),
    _: 1
  }, 8, ["class"]), !$data.showAddNew ? (_openBlock(), _createBlock(_component_ButtonBasic, {
    key: 0,
    label: $props.itemName,
    "class": "appsContainer__opener-button",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.openPanel();
    })
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode("New "), _renderSlot(_ctx.$slots, "buttonIcon")];
    }),
    _: 3
  }, 8, ["label"])) : _createCommentVNode("", true)]), $data.showListA ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [_renderSlot(_ctx.$slots, "listA")])) : _createCommentVNode("", true), $data.showListB ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [_renderSlot(_ctx.$slots, "listB")])) : _createCommentVNode("", true), $data.showAddNew ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("h2", null, "Add a new " + _toDisplayString($props.itemName), 1)]), _renderSlot(_ctx.$slots, "addNewForm"), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_ButtonBasic, {
    label: "Add Todo Item",
    "class": "appsContainer__button",
    onClick: $options.addTodo
  }, null, 8, ["onClick"]), _createElementVNode("div", {
    "class": "appsContainer__cancel-add-button",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $data.showAddNew = false;
    })
  }, " Cancel")])])])) : _createCommentVNode("", true)]);
}